<template>
  <div class="step" :class="{ 'step_active': active }">
    <h3 class="step__title step__title_incspace">Проверьте данные</h3>
    <h4 class="step__minititle step__minititle_spaced-bottom">Данные о заявке</h4>
    <LinkField :step="1" name="Номер заявки" :value="form.request_number" />
    <LinkField :step="1" name="ФИО Заявителя" :value="form.applicant.name" />
<!--    <template v-for="i in contractCount" :key="i">
      <LinkField :step="1" name="Номер договора страхования" :value="form.contracts[i - 1].id" />
      <LinkField :step="1" name="Дата заключения договора страхования" :value="form.contracts[i - 1].date" />
    </template>-->
<!--    <h4 class="step__minititle step__minititle_spaced">Данные Заявителя</h4>
    <LinkField :step="2" name="ФИО Заявителя" :value="form.applicant.name" />
    <LinkField :step="2" name="Дата рождения Заявителя" :value="form.applicant.birthdate" />
    <LinkField :step="2" name="Документ удостоверяющий личность" :value="form.applicant.doc.type" />
    <LinkField :step="2" name="Серия документа" :value="form.applicant.doc.series" />
    <LinkField :step="2" name="Номер документа" :value="form.applicant.doc.number" />
    <LinkField :step="2" name="Код подразделения" :value="form.applicant.doc.code" />
    <LinkField :step="2" name="Дата выдачи документа " :value="form.applicant.doc.releasedate" />
    <h4 class="step__minititle step__minititle_spaced">Контакты</h4>
    <LinkField :step="3" name="Текущий ваш адрес проживания" :value="form.applicant.address" />
    <LinkField :step="3" name="Номер мобильного телефона" :value="form.applicant.tel" />
    <LinkField :step="3" name="E-mail" :value="form.applicant.email" />
    <LinkField :step="3" name="Заявитель действует от:" :value="form.applicant.onbehalf" />
    <h4 class="step__minititle step__minititle_spaced">Данные Выгодоприобретателя</h4>
    <template v-for="(b, i) in form.beneficiaries" :key="i">
      <LinkField :step="4" name="ФИО Выгодоприобретателя" :value="b.name" />
      <LinkField :step="4" name="Дата рождения Выгодоприобретателя" :value="b.birthdate" />
      <LinkField :step="4" name="Документ подтверждающий личность" :value="b.doc.type" />
      <LinkField :step="4" name="Серия документа" :value="b.doc.series" />
      <LinkField :step="4" name="Номер документа" :value="b.doc.number" />
      <LinkField :step="4" name="Код подразделения" :value="b.doc.code" />
      <LinkField :step="4" name="Дата выдачи документа " :value="b.doc.releasedate" />
      <LinkField :step="4" name="ИНН Выгодоприобретателя" :value="b.INN" />
      <LinkField :step="4" name="Адрес проживания Выгодоприобретателя" :value="b.address" />
      <LinkField :step="4" name="Является публичным должностным лицом" :value="b.publicPerson ? 'Да' : 'Нет'" />
      <LinkField :step="4" name="Степень родства Заявителя с Застрахованным" :value="b.relationship" />
      <LinkField :step="4" name="ФИО Застрахованного" :value="b.insuredperson.name" />
      <LinkField :step="4" name="Дата рождения Застрахованного" :value="b.insuredperson.birthdate" />
    </template>
    <h4 class="step__minititle step__minititle_spaced">Информация о событии</h4>
    <LinkField :step="5" name="Дата наступления события" :value="form.event.date" />
    <LinkField :step="5" name="Страховое событие" :value="form.event.type" />
    <LinkField :step="5" name="Причина страхового события" :value="form.event.reason" />
    <LinkField :step="5" name="Описание обстоятельств наступления события" :value="form.event.description" />-->
    <h4 class="step__minititle step__minititle_spaced">Документы</h4>
<!--    <LinkField :step="6" mode="files" name="Заполненный бланк Заявления  (от каждого Выгодоприобретателя, если данное заявление не содержит всей информации)" :value="Array.from(form.files.blank)" />
    <LinkField :step="6" mode="files" name="Паспорт (основной разворот и страница с пропиской)" :value="Array.from(form.files.passport)" />
    <LinkField :step="6" mode="files" name="Выписка из амбулаторной карты / Извещение о больном Ф090/У (для онкозаболеваний) / Выписка из Канцер-регистра (для онкозаболеваний)" :value="Array.from(form.files.vipiska)" />
    <LinkField :step="6" mode="files" name="Постановление о возбуждении/ отказе в возбуждении уголовного дела" :value="Array.from(form.files.criminalCase)" />
    <LinkField :step="6" mode="files" name="Справка о смерти/ Медицинское свидетельство о смерти" :value="Array.from(form.files.deathproof)" />
    <LinkField :step="6" mode="files" name="Свидетельство о праве на наследство по закону или справка о круге наследников" :value="Array.from(form.files.legacyproof)" />
    <LinkField :step="6" mode="files" name="Акт судебно-медицинского исследования трупа" :value="Array.from(form.files.bodyresearchproof)" />
    <LinkField :step="6" mode="files" name="Справка об установлении группы инвалидности" :value="Array.from(form.files.invalidproof)" />
    <LinkField :step="6" mode="files" name="Протокол медико-социальной экспертизы" :value="Array.from(form.files.medprotocol)" />-->
    <LinkField :step="1" mode="files" name="Прикрепить дополнительные документы" :value="Array.from(form.files.additinal)" />
<!--    <h4 class="step__minititle step__minititle_spaced">Банковские реквизиты Выгодоприобретателя <br class="onlydesk">для получателя выплаты</h4>
    <LinkField :step="7" name="ФИО получателя выплаты (Выгодоприобретателя)" :value="form.bankdata.receiver" />
    <LinkField :step="7" name="БИК банка получателя" :value="form.bankdata.BIK" />
    <LinkField :step="7" name="Наименование банка" :value="form.bankdata.bankname" />
    <LinkField :step="7" name="Номер лицевого счета получателя" :value="form.bankdata.accountNumber" />-->
    <Btn class="step__next" @click.stop.prevent="$store.commit('ad_storage/nextStep')">Далее</Btn>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import LinkField from '../LinkField.vue';
import { /*mapGetters,*/ mapState } from 'vuex';

export default {
  props: {
    active: { type: Boolean }
  },
  components: { LinkField, Btn },
  computed: {
    ...mapState('ad_storage',['form']),
    // ...mapGetters('ad_storage',['contractCount']),

  }
}
</script>

<style lang="sass" scoped>

</style>